import SessionConfig from '../../model/SessionConfig'

export enum PassType {
  INDIVIDUAL = 'individual',
  TEAM = 'team',
  LEADER = 'leader',
}

export interface TeamData {
  name: string
  targetMemberCount?: number
}

export default interface PaymentService {
  createCheckoutSession(
    passType: PassType,
    config: SessionConfig,
    successUrl: string,
    cancelUrl: string,
    challengeId: string,
    teamData?: TeamData,
    teamId?: string,
    actionType?: string,
  ): Promise<string>
}
